<mat-card class="system-card">
	<mat-card-header>
		<mat-card-title>Podsumowanie</mat-card-title>
	</mat-card-header>
	<mat-card-content>
		<div class="summary-breakdown">
			<div class="breakdown-row">
				<span class="breakdown-label">
					Nawigator
					@if (state.isMonthlyBase()) {
						<small class="breakdown-sublabel">Wypłata miesięczna</small>
					}
				</span>
				<span class="breakdown-amount amount-positive">
					+ {{ state.nawigatorTotalPln() | priceCurrency: 'PLN' }}
				</span>
			</div>
			@if (state.seasonalBonuses().length > 0) {
				<div class="breakdown-row">
					<span class="breakdown-label">
						Premia sezonowa
						<small class="breakdown-sublabel">
							{{ state.seasonalBonusDays() }} dni pracy w okresie
							@for (season of state.seasonalBonuses(); track season.date_from) {
								<span class="breakdown-season">
									{{ season.date_from }}–{{ season.date_to }}:
									{{ season.rate_per_day | priceCurrency: 'PLN' }}/dzień
								</span>
							}
						</small>
					</span>
					<span class="breakdown-amount amount-positive">
						+ {{ state.seasonalBonusPln() | priceCurrency: 'PLN' }}
					</span>
				</div>
			}
			<div class="breakdown-row">
				<span class="breakdown-label">
					Dieta (Enova − Gratyfikant)
					<small class="breakdown-sublabel">
						{{ state.enovaTotal() ?? 0 | priceCurrency: 'PLN' }} −
						{{ state.gratyfikantTotal() ?? 0 | priceCurrency: 'PLN' }}
					</small>
				</span>
				<span
					class="breakdown-amount"
					[class.amount-negative]="state.effectiveDietaPln() >= 0"
					[class.amount-positive]="state.effectiveDietaPln() < 0"
				>
					{{ state.effectiveDietaPln() >= 0 ? '−' : '+' }}
					{{
						(state.effectiveDietaPln() < 0 ? -state.effectiveDietaPln() : state.effectiveDietaPln())
							| priceCurrency: 'PLN'
					}}
				</span>
			</div>
			<div class="breakdown-row">
				<span class="breakdown-label">Gratyfikant</span>
				<span class="breakdown-amount amount-negative">
					− {{ state.gratyfikantTotal() ?? 0 | priceCurrency: 'PLN' }}
				</span>
			</div>
			<div class="breakdown-row">
				<span class="breakdown-label">Dodatki / potrącenia</span>
				<span class="breakdown-amounts">
					<span
						class="breakdown-amount"
						[class.amount-positive]="state.settlementNetPln() >= 0"
						[class.amount-negative]="state.settlementNetPln() < 0"
					>
						{{ state.settlementNetPln() >= 0 ? '+' : '−' }}
						{{
							(state.settlementNetPln() < 0 ? -state.settlementNetPln() : state.settlementNetPln())
								| priceCurrency: 'PLN'
						}}
					</span>
					@if (state.settlementNetEur() !== 0) {
						<span
							class="breakdown-amount breakdown-amount-secondary"
							[class.amount-positive]="state.settlementNetEur() >= 0"
							[class.amount-negative]="state.settlementNetEur() < 0"
						>
							{{ state.settlementNetEur() >= 0 ? '+' : '−' }}
							{{
								(state.settlementNetEur() < 0 ? -state.settlementNetEur() : state.settlementNetEur())
									| priceCurrency: 'EUR'
							}}
						</span>
					}
				</span>
			</div>
			<div class="breakdown-row">
				<span class="breakdown-label">
					Kasa
					@if (state.kasaCarriesAnything()) {
						<small class="breakdown-sublabel">
							Na kolejny miesiąc przechodzi
							@if (state.kasaSplit().carriedPln !== 0) {
								<span class="breakdown-season">
									{{ abs(state.kasaSplit().carriedPln) | priceCurrency: 'PLN' }}
								</span>
							}
							@if (state.kasaSplit().carriedEur !== 0) {
								<span class="breakdown-season">
									{{ abs(state.kasaSplit().carriedEur) | priceCurrency: 'EUR' }}
								</span>
							}
						</small>
					}
				</span>
				<span class="breakdown-amounts">
					@if (state.kasaDeductedPln() !== 0 || state.kasaPayoutEur() === 0) {
						<span
							class="breakdown-amount"
							[class.amount-positive]="state.kasaDeductedPln() < 0"
							[class.amount-negative]="state.kasaDeductedPln() >= 0"
						>
							{{ state.kasaDeductedPln() >= 0 ? '−' : '+' }}
							{{ abs(state.kasaDeductedPln()) | priceCurrency: 'PLN' }}
						</span>
					}
					@if (state.kasaPendingEur() !== 0) {
						@if (state.kasaEurInCash()) {
							<span
								class="breakdown-amount"
								[class.amount-positive]="state.kasaPayoutEur() > 0"
								[class.amount-negative]="state.kasaPayoutEur() < 0"
							>
								{{ state.kasaPayoutEur() >= 0 ? '+' : '−' }}
								{{ abs(state.kasaPayoutEur()) | priceCurrency: 'EUR' }}
							</span>
							<span class="breakdown-amount breakdown-amount-secondary">w gotówce, bez przeliczania</span>
						} @else {
							<span class="breakdown-amount breakdown-amount-secondary">
								w tym {{ abs(state.kasaSplit().settledEur) | priceCurrency: 'EUR' }} =
								{{ abs(state.kasaSplit().settledEurPln) | priceCurrency: 'PLN' }}
							</span>
						}
					}
				</span>
			</div>
		</div>
		<h3 class="summary-section-title">Podział wypłaty</h3>
		<div class="summary-row">
			<mat-form-field appearance="outline" class="display-only">
				<mat-label>Suma miesięczna PLN</mat-label>
				<input matInput [value]="state.sumAllPln() | priceFormat" readonly tabindex="-1" />
			</mat-form-field>
		</div>
		<h3 class="summary-section-title">Kasa</h3>
		<div class="summary-row">
			@if (state.isSettled()) {
				<mat-form-field appearance="outline" class="display-only">
					<mat-label>Rozliczono PLN</mat-label>
					<input matInput [value]="state.kasaSplit().settledPln | priceFormat" readonly tabindex="-1" />
				</mat-form-field>
				<mat-form-field appearance="outline" class="display-only">
					<mat-label>Rozliczono EUR</mat-label>
					<input matInput [value]="state.kasaSplit().settledEur | priceFormat" readonly tabindex="-1" />
				</mat-form-field>
			} @else {
				<mat-form-field appearance="outline" subscriptSizing="dynamic">
					<mat-label>Rozlicz PLN</mat-label>
					<input
						matInput
						type="text"
						inputmode="decimal"
						[value]="state.kasaSplit().settledPln | priceFormat"
						(focus)="$any($event.target).select()"
						(blur)="onKasaSettlePlnBlur($any($event.target))"
					/>
					<mat-hint>Saldo: {{ state.ledgerPendingTotals().pln | priceCurrency: 'PLN' }}</mat-hint>
				</mat-form-field>
				<mat-form-field appearance="outline" subscriptSizing="dynamic">
					<mat-label>Rozlicz EUR</mat-label>
					<input
						matInput
						type="text"
						inputmode="decimal"
						[value]="state.kasaSplit().settledEur | priceFormat"
						(focus)="$any($event.target).select()"
						(blur)="onKasaSettleEurBlur($any($event.target))"
					/>
					<mat-hint>Saldo: {{ state.ledgerPendingTotals().eur | priceCurrency: 'EUR' }}</mat-hint>
				</mat-form-field>
				@if (state.kasaCarriesAnything()) {
					<button
						mat-stroked-button
						type="button"
						[disabled]="state.kasaSettlementSaving()"
						(click)="state.settleWholeKasa()"
					>
						<span class="btn-content"><i class="fa-solid fa-rotate-left"></i> Rozlicz całość</span>
					</button>
				}
			}

			@if (state.hasEurKasa()) {
				<div class="kasa-eur-mode">
					<mat-slide-toggle
						[checked]="state.kasaEurInCash()"
						[disabled]="state.isSettled() || state.kasaSettlementSaving()"
						(change)="state.saveKasaEurInCash($event.checked)"
					>
						Wydaj EUR w gotówce EUR (bez przeliczania na PLN)
					</mat-slide-toggle>
					<small class="kasa-eur-mode-hint">
						@if (state.kasaEurInCash()) {
							{{ abs(state.kasaPayoutEur()) | priceCurrency: 'EUR' }}
							{{ state.kasaPayoutEur() >= 0 ? 'do wydania w EUR' : 'do zwrotu w EUR' }} — suma miesięczna
							PLN zostaje bez tej kwoty
						} @else {
							{{ abs(state.kasaSplit().settledEur) | priceCurrency: 'EUR' }} przeliczone po kursie z
							wpisów kasowych na {{ abs(state.kasaSplit().settledEurPln) | priceCurrency: 'PLN' }}
						}
					</small>
				</div>
			}

			@if (state.kasaCarriesAnything()) {
				<div class="split-status split-status-info" role="status">
					<i class="fa-solid fa-arrow-right-long"></i>
					<div class="split-status-body">
						<strong>Część kasy przechodzi na kolejny miesiąc</strong>
						<span>
							@if (state.kasaSplit().carriedPln !== 0) {
								{{ abs(state.kasaSplit().carriedPln) | priceCurrency: 'PLN' }}
							}
							@if (state.kasaSplit().carriedEur !== 0) {
								{{ abs(state.kasaSplit().carriedEur) | priceCurrency: 'EUR' }}
							}
							@if (state.isSettled()) {
								— zapisane w kasie jako wpis „Przeniesienie z rozliczenia”
							} @else {
								— po zamknięciu miesiąca wróci do kasy jako osobny wpis
							}
						</span>
					</div>
				</div>
			}

			@if (state.kasaSettlementError(); as error) {
				<p class="summary-hint summary-hint-error" role="alert">
					<i class="fa-solid fa-triangle-exclamation"></i>
					{{ error }}
				</p>
			}

			<p class="summary-hint">
				<i class="fa-solid fa-circle-info"></i>
				Saldo kasy kierowcy, na plus = odjęte od wypłaty. Rozliczane kwoty są już wliczone w sumę miesięczną
				(EUR po kursie z wpisów kasowych, chyba że wydajesz je w EUR). Pusta wartość = rozlicz całe saldo.
			</p>
		</div>

		<h3 class="summary-section-title">Wydanie gotówki</h3>
		<div class="summary-row">
			<mat-form-field appearance="outline" subscriptSizing="dynamic">
				<mat-label>Wydano gotówki PLN</mat-label>
				<input
					matInput
					type="text"
					inputmode="decimal"
					[value]="state.cashPayoutPln() | priceFormat"
					(focus)="$any($event.target).select()"
					(blur)="onCashPayoutPlnBlur($any($event.target))"
				/>
			</mat-form-field>
			<mat-form-field appearance="outline" subscriptSizing="dynamic">
				<mat-label>Wydano gotówki EUR</mat-label>
				<input
					matInput
					type="text"
					inputmode="decimal"
					[value]="state.cashPayoutEur() | priceFormat"
					(focus)="$any($event.target).select()"
					(blur)="onCashPayoutEurBlur($any($event.target))"
				/>
				@if (state.cashToPayoutEur() !== 0) {
					<mat-hint>
						{{ state.cashToPayoutEur() > 0 ? 'Do wydania' : 'Do zwrotu' }}:
						{{ abs(state.cashToPayoutEur()) | priceCurrency: 'EUR' }}
					</mat-hint>
				}
			</mat-form-field>
			@if (state.cashPayoutBy(); as paidBy) {
				<span class="payout-by" matTooltip="Osoba, która ostatnio zmieniła wydaną kwotę">
					<i class="fa-solid fa-user"></i>
					Wydał: {{ paidBy }}
				</span>
			}

			@if (state.hasCashPayout()) {
				@if (state.cashPayoutComplete()) {
					<div class="split-status split-status-success" role="status">
						<i class="bi bi-check-circle-fill"></i>
						<div class="split-status-body">
							<strong>Gotówka wydana w całości</strong>
							<span>Zgadza się z podziałem wypłaty</span>
						</div>
					</div>
				} @else {
					<div class="split-status split-status-error" role="status">
						<i class="bi bi-exclamation-triangle-fill"></i>
						<div class="split-status-body">
							<strong>Wydana gotówka nie zgadza się z podziałem</strong>
							@if (state.cashPayoutRemainingPln() !== 0) {
								<span>
									{{ state.cashPayoutRemainingPln() > 0 ? 'Do wydania' : 'Nadwyżka' }}:
									{{ abs(state.cashPayoutRemainingPln()) | priceCurrency: 'PLN' }}
								</span>
							}
							@if (state.cashPayoutRemainingEur() !== 0) {
								<span>
									{{ eurRemainingLabel() }}:
									{{ abs(state.cashPayoutRemainingEur()) | priceCurrency: 'EUR' }}
								</span>
							}
						</div>
					</div>
				}
			}
		</div>
		<div class="summary-row">
			<mat-form-field appearance="outline" subscriptSizing="dynamic">
				<mat-label>Data wydania gotówki</mat-label>
				<input
					matInput
					[matDatepicker]="cashPayoutPicker"
					[value]="cashPayoutDateValue()"
					(dateChange)="onCashPayoutDateChange($event.value)"
				/>
				<mat-datepicker-toggle matIconSuffix [for]="cashPayoutPicker"></mat-datepicker-toggle>
				<mat-datepicker #cashPayoutPicker></mat-datepicker>
			</mat-form-field>
			<mat-form-field appearance="outline" subscriptSizing="dynamic" class="cash-payout-time">
				<mat-label>Godzina</mat-label>
				<input
					matInput
					type="time"
					[value]="cashPayoutTimeValue()"
					[disabled]="!cashPayoutDateValue()"
					(change)="onCashPayoutTimeChange($any($event.target).value)"
				/>
			</mat-form-field>
			@if (state.cashPayoutDate()) {
				<button
					mat-button
					type="button"
					class="cash-payout-clear"
					[disabled]="state.cashPayoutSaving()"
					(click)="onCashPayoutDateChange(null)"
				>
					<mat-icon><i class="fa-solid fa-xmark"></i></mat-icon>
					Wyczyść datę
				</button>
			}
			@if (state.cashPayoutSaving()) {
				<span class="notes-saving">
					<mat-spinner diameter="14" class="me-1 d-inline-block"></mat-spinner> Zapisywanie…
				</span>
			}
		</div>

		@if (state.cashPayoutError()) {
			<div class="alert alert-danger d-flex align-items-center mb-2" role="alert">
				<i class="bi bi-exclamation-triangle-fill me-2"></i>
				<div><strong>Błąd zapisu wydania gotówki:</strong> {{ state.cashPayoutError() }}</div>
			</div>
		}

		<h3 class="summary-section-title">Uwagi</h3>
		<div class="summary-notes">
			<mat-form-field appearance="outline" class="summary-notes-field">
				<mat-label>Uwagi do rozliczenia</mat-label>
				<textarea
					matInput
					rows="3"
					[value]="state.settlementNotes()"
					[readonly]="state.isSettled()"
					(input)="state.settlementNotes.set($any($event.target).value)"
					(blur)="state.saveNotes()"
				></textarea>
			</mat-form-field>
			<mat-form-field appearance="outline" class="summary-notes-field">
				<mat-label>Uwagi do wypłaty</mat-label>
				<textarea
					matInput
					rows="3"
					[value]="state.paymentNotes()"
					[readonly]="state.isSettled()"
					(input)="state.paymentNotes.set($any($event.target).value)"
					(blur)="state.saveNotes()"
				></textarea>
			</mat-form-field>
		</div>

		@if (state.notesError()) {
			<div class="alert alert-danger d-flex align-items-center mb-2" role="alert">
				<i class="bi bi-exclamation-triangle-fill me-2"></i>
				<div><strong>Błąd zapisu uwag:</strong> {{ state.notesError() }}</div>
			</div>
		}
		@if (state.settleError()) {
			<div class="alert alert-danger d-flex align-items-center mb-2" role="alert">
				<i class="bi bi-exclamation-triangle-fill me-2"></i>
				<div><strong>Błąd rozliczenia:</strong> {{ state.settleError() }}</div>
			</div>
		}

		<div class="settle-bar">
			<div class="settle-status">
				@if (!state.isSettled() && state.notesSaving()) {
					<span class="notes-saving"
						><mat-spinner diameter="14" class="me-1 d-inline-block"></mat-spinner> Zapisywanie uwag…</span
					>
				}
			</div>
			@if (state.isSettled()) {
				<app-salary-month-status />
			} @else {
				<button
					mat-raised-button
					color="primary"
					type="button"
					[disabled]="state.settleLoading()"
					(click)="state.settleMonth()"
				>
					@if (state.settleLoading()) {
						<mat-spinner diameter="18" class="me-2 d-inline-block"></mat-spinner>
					}
					Rozlicz miesiąc ({{ state.selectedMonthLabel() }})
				</button>
			}
		</div>
	</mat-card-content>
</mat-card>
